module.exports = __webpack_public_path__ + "img/pin-protect-aktiv.44c80e0e.svg";